import React, { useRef, useState, useEffect } from 'react';
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";
import moment from "moment";
import { useForm } from "react-hook-form";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import SelectGeneric from "../../../components/select/selectGeneric";
import { showToastCustom } from "../../../components/toast/customToast";
import { categoryPromotionProvider } from "../../../providers/categoryPromotionProvider";
import {
    FL_CAT_PROM,
    FL_CODE,
    FL_COUPON,
    FL_END_DATE,
    FL_PAX_MAX,
    FL_PAX_MIN,
    FL_START_DATE,
    FL_STATUS, FL_TAX_INCLUDED, FL_TOP_PREFERENCE
} from "../../../components/i18n/formLabels";
import { PH_CODE, PH_COUPON,  PH_PAX_MAX, PH_PAX_MIN } from "../../../components/i18n/placeHolders";
import { error, INTERNATIONAL, REQUIRED, selectOption } from "../../../components/i18n/i18n";
import { TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import PromotionControllerLangs from "./_langs";
import {promotionService} from "../../../jwt/_services/promotions/promotionService";
import {getStateByPath} from "../../../redux/selectors";
import TabOptionSection from "./tabOptionSection/TabOptionSection";
import Separator from "../../../components/Separator";

import { setLoading, setViewMode, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import BenefitSection from "./benefitSection/BenefitSection";
import Switch from "react-bootstrap-switch";
import {GenericButton} from "../../../components/buttons/customButtons";
import TranslateButton from "../../../components/buttons/TranslateButton";
import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";
import {promotionMediaService} from "../../../jwt/_services/promotions/promotionMediaService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

const PromotionControllerForm = (props) => {
    const toDate = moment(new Date()).format('YYYY-MM-DD')

    const componentState = useSelector(state => getStateByPath(state, props.path));

    const {path} = componentState;
    const {app, editMode, disableInputs, domainObject} = componentState?.data;

    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [categoryPromotionId, setCategoryPromotionId] = useState(editMode ? domainObject?.categoryPromotion?.id : null);
    const [startDate, setStartDate] = useState(editMode ? domainObject?.startDate : null);
    const [endDate, setEndDate] = useState(editMode ? domainObject?.endDate : null);
    const [cotizationDate, setCotizationDate] = useState(editMode ? domainObject?.cotizationDate : null);
    const [status, setStatus] = useState(domainObject?.status !== undefined ? domainObject?.status : true);
    const [taxIncluded, setTaxIncluded] = useState(domainObject?.taxIncluded !== undefined ? domainObject?.taxIncluded : false);
    const [topPreference, setTopPreference] = useState(domainObject?.topPreference !== undefined ? domainObject?.topPreference : false);
    const [useMaxMinToGetPrice, setUseMaxMinToGetPrice] = useState(domainObject?.useMaxMinToGetPrice !== undefined ? domainObject?.useMaxMinToGetPrice : false);

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);




    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: (domainObject?.code || 'promo_' + getCurrentDateForCodeField()), // AUTOCODE
                coupon: domainObject?.coupon,
                showOrder: domainObject?.showOrder,
                defaultImage: domainObject?.defaultImage,
                paxMax: domainObject?.paxMax,
                paxMin: domainObject?.paxMin,
                daysPrev: domainObject?.daysPrev,
                startDate,
                endDate,
                cotizationDate,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);






    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: (domainObject?.code || 'promo_' + getCurrentDateForCodeField()), // AUTOCODE
            coupon: domainObject?.coupon,
            showOrder: domainObject?.showOrder,
            defaultImage: domainObject?.defaultImage,
            paxMax: domainObject?.paxMax,
            paxMin: domainObject?.paxMin,
            daysPrev: domainObject?.daysPrev,
            startDate,
            endDate,
            cotizationDate,
        }
    });

    const onSubmit = (data, _) => {
        if (categoryPromotionId == null)
            return showToastCustom(error, selectOption);

        let dataRequest = {
            noDb: false,
            allDb: false,
            fbDataBase: {id: app?.fbDataBase.id},
            item: {
                ...data,
                langs: langs,
                //Booleans
                status: status,
                taxIncluded: taxIncluded,
                topPreference: topPreference,
                useMaxMinToGetPrice: useMaxMinToGetPrice,
                //End booleans
                startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
                endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
                cotizationDate: cotizationDate ? moment(cotizationDate).format('YYYY-MM-DD') : null,
                categoryPromotion: {id: categoryPromotionId}
            }
        };

        dataRequest.item.langs.map(lang => {
            lang.fbDataBase = { id: app?.fbDataBase.id }
        })

        // console.log(dataRequest);
        // return;

        setLoading(true);

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, promotionService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, promotionService, dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(false, false, false);
        props.onClose();
    }

    const refreshObject = () => genericIndexedActions.get(path, promotionService, domainObject?.id, app?.fbDataBase?.id);

    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={!editMode ? 'card-modal-medium' : 'card-modal-big' }>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { ('App' + app?.code || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={promotionService} />
                                {/*<GenericButton*/}
                                {/*    style={'danger-secondary'}*/}
                                {/*    toolTip={TT_DELETE}*/}
                                {/*    icon={'fa-trash'}*/}
                                {/*    permission={'delete'}*/}
                                {/*    onClick={notImplementedAction}*/}
                                {/*/>*/}
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md={editMode ? 8 : 12}>
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_CODE}</Label>
                                        <Input
                                            type="text"
                                            name="code"
                                            placeholder={PH_CODE}
                                            innerRef={register}
                                            disabled={disableInputs}
                                            className={(errors.code ? ' is-invalid' : '')}
                                        />
                                        {errors.code && <div className="invalid-feedback"
                                                             style={{'display': 'block'}}>{errors?.code?.message}</div>}
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_COUPON}</Label>
                                        <Input type="text" name="coupon"
                                               placeholder={PH_COUPON}
                                               innerRef={register}
                                               disabled={disableInputs}/>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>{FL_CAT_PROM}</Label>
                                        <br/>
                                        <SelectGeneric
                                            isDisabled={disableInputs}
                                            initialValue={categoryPromotionId}
                                            setExternalValue={setCategoryPromotionId}
                                            provider={categoryPromotionProvider}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_PAX_MAX}</Label>
                                        <Input
                                            type="text"
                                            name="paxMax"
                                            placeholder={PH_PAX_MAX}
                                            innerRef={register}
                                            disabled={disableInputs}
                                            pattern='([0-9]+\/[0-9]+)'
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_PAX_MIN}</Label>
                                        <Input
                                            type="text"
                                            name="paxMin"
                                            placeholder={PH_PAX_MIN}
                                            innerRef={register}
                                            disabled={disableInputs}
                                            pattern='([0-9]+\/[0-9]+)'
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_TOP_PREFERENCE}</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={topPreference}
                                                innerRef={register}
                                                onChange={_ => setTopPreference(!topPreference)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_TAX_INCLUDED}</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={taxIncluded}
                                                innerRef={register}
                                                onChange={_ => setTaxIncluded(!taxIncluded)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>Imagen default</Label>
                                        <Input
                                            type="text"
                                            name="defaultImage"
                                            placeholder={'Imagen por defecto'}
                                            innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{'Habilitación'}</h2>
                                </div>
                                <div className={''}>
                                    <Row>
                                        <Col md="3">
                                            <Label>{FL_START_DATE}</Label>
                                            <Input
                                                type="date"
                                                name="startDate"
                                                value={startDate || ''}
                                                min={startDate || toDate}
                                                disabled={disableInputs}
                                                onChange={e => setStartDate(e.target.value)}
                                                innerRef={register}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <Label>{FL_END_DATE}</Label>
                                            <Input
                                                type="date"
                                                name="endDate"
                                                value={endDate || ''}
                                                min={startDate || toDate}
                                                disabled={disableInputs}
                                                onChange={e => setEndDate(e.target.value)}
                                                innerRef={register}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <Label>{FL_STATUS}</Label>
                                                <br/>
                                                <Switch animate={true} offText={"No"} onText={"Si"}
                                                        value={status}
                                                        innerRef={register}
                                                        onChange={_ => setStatus(!status)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{'Configuración de cotización'}</h2>
                                </div>
                                <div className={''}>
                                    <Row>
                                        <Col md="3">
                                            <FormGroup>
                                                <Label>{'Usar pax min para cotizar'}</Label>
                                                <br/>
                                                <Switch animate={true} offText={"No"} onText={"Si"}
                                                        value={useMaxMinToGetPrice}
                                                        innerRef={register}
                                                        onChange={_ => setUseMaxMinToGetPrice(!useMaxMinToGetPrice)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <Label>{'Cotizar con fecha exacta'}</Label>
                                            <Input
                                                type="date"
                                                name="cotizationDate"
                                                value={cotizationDate || ''}
                                                disabled={disableInputs}
                                                onChange={e => setCotizationDate(e.target.value)}
                                                innerRef={register}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <Label>{'Cotizar con dias de antelación'}</Label>
                                                <Input type="number"
                                                       name="daysPrev"
                                                       step={1}
                                                       min={0}
                                                       innerRef={register}
                                                       disabled={disableInputs}/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <br/>
                            <br/>
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{INTERNATIONAL}</h2>
                                </div>
                                <div className={''}>
                                    <PromotionControllerLangs langs={langs} setLangs={setLangs} translatableLangs={domainObject?.translatedLangs || []}/>
                                </div>
                            </div>
                        </Col>
                        <Col md={editMode ? 4 : 0}>
                            {
                                // 20251106 - Imagenes deshabilitadas temporalmente por incompatibilidad con App Parques
                                // domainObject?.id && <ImagePicker
                                //     className={'promotion'}
                                //     title={'Media'}
                                //     app={app}
                                //     service={promotionService}
                                //     baseMediaService={promotionMediaService}
                                //     objectMedia={domainObject}
                                //     afterUpload={refreshObject}
                                // />
                            }
                            <br/>
                            {domainObject?.id && <TabOptionSection path={path} parent={domainObject}/>}
                            <br/>
                            {domainObject?.id && <BenefitSection path={path} parent={domainObject}/>}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Form>

        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    setViewMode,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionControllerForm)
